<template>
  <div class="p-5 flex flex-col">
    <p class="text-primary md:text-black font-semibold text-lg md:text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <vs-row
      vs-w="12"
      class="my-5 filter-container"
    >
      <vs-col vs-w="1">
        <p class="font-semibold">
          Filter
        </p>
      </vs-col>
      <vs-col vs-w="3" />
      <vs-col
        vs-w="8"
        class="flex justify-end"
      >
        <div class="flex flex-row gap-x-4 items-stretch">
          <div class="flex items-center w-full">
            <select-with-multiple
              v-model="filters.flf_fc_nominate"
              placeholder="Select FLF/FC Nominate"
              :options="flfFcOptions"
              style="min-width: 260px;"
              :disabled="isFlfFc"
            />
          </div>
          <div class="flex items-center w-full">
            <date-picker
              style="min-width: 200px;"
              type="month"
              format="MMM YYYY"
              value-type="format"
              placeholder="Select Month"
              v-model="filters.month_year"
            />
          </div>
          <div class="flex items-center">
            <vs-button
              type="border"
              color="primary"
              class="self-center font-semibold"
              style="min-width: 100px;"
              @click="() => {
                filters.month_year = moment().format('MMM YYYY')
                filters.flf_fc_nominate = []
                filters.sort_by = 'commence_loading'
                filters.sort_dir = 'desc'
                if (!isEmpty(me.flfFcNominate))
                  filters.flf_fc_nominate = [{ value: me.flfFcNominate.id, text: me.flfFcNominate.name }]

                $refs.tabletop.$emit('reset-search')
              }"
            >
              Reset
            </vs-button>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <div
      class="flex flex-col p-5 bg-white rounded-md"
    >
      <table-top
        is-search-has-border
        :page-size-start="false"
        class="mt-6"
        @fetch="fetchCargoContaminations"
        ref="tabletop"
      />
      <data-table
        class="mt-6"
        :table-header="tableHeaders"
        :table-data="tableData"
        :sort-by="filters.sort_by"
        :sort-dir="filters.sort_dir"
        :loading="isBusy"
        :frozen-columns="0"
        body-height="100vh"
        @sort="sort"
      >
        <template #no="{ index }">
          {{ (currentPage - 1) * pageSize + index + 1 }}
        </template>
        <template #action="{ row }">
          <div class="flex flex-row gap-x-3 justify-center">
            <template>
              <div
                v-if="!!row.report_submitted_date"
                class="flex items-center justify-center icon-transparent-bg"
                :class="{
                  'disable': isDownloading
                }"
                @click="downloadReport(row)"
              >
                <img :src="require('@/assets/shipo-icon-file-download-primary.svg')">
              </div>
            </template>
          </div>
        </template>
        <template #company="{ row }">
          {{ row.company || '-' }}
        </template>
        <template #commence_loading="{ row }">
          {{ row.commence_loading ? moment(row.commence_loading).format('DD MMM YYYY HH:mm') : '-' }}
        </template>
        <template #report_submitted_date="{ row }">
          {{ row.report_submitted_date ? moment(row.report_submitted_date).format('DD MMM YYYY HH:mm') : '-' }}
        </template>
        <template #total_tug_barge="{ row }">
          <div class="w-full text-center">
            {{ row.total_tug_barge || '-' }}
          </div>
        </template>
      </data-table>
      <table-bottom
        class="mt-6"
        @fetch="fetchCargoContaminations"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import DatePicker from '@/components/datePicker'
import SelectWithMultiple from '@/components/selectWithMultiple'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'
import downloadUtils from '@/utils/downloadUtils'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  components: {
    DataTable,
    TableTop,
    TableBottom,
    DatePicker,
    SelectWithMultiple
  },
  computed: {
    ...mapGetters({
      me: 'Auth/me',
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      totalPage: 'Table/totalPage',
      cargoContaminations: 'CargoContamination/cargoContaminations',
      fileExport: 'CargoContamination/fileExport',
      flfFcNominates: 'VesselLineUp/flfFcNominates'
    }),
    isFlfFc() {
      return !this.isEmpty(this.me.flfFcNominate)
    }
  },
  data() {
    const defaultMonth = this.moment().format('MMM YYYY')
    
    return {
      filters: {
        sort_by: 'commence_loading',
        sort_dir: 'desc',
        month_year: defaultMonth,
        flf_fc_nominate: []
      },
      tableHeaders: [
        { key: 'no', label: 'No', width: '50px' },
        { key: 'action', label: 'Action' },
        { key: 'company', label: 'Company', sortable: true },
        { key: 'vessel_name', label: 'Vessel Name', sortable: true },
        { key: 'commence_loading', label: 'Commenced Loading', sortable: true },
        { key: 'total_tug_barge', label: 'Total Tug & Barge', sortable: true },
        { key: 'report_submitted_date', label: 'Report Submitted Date', sortable: true }
      ],
      tableData: [],
      isBusy: false,
      isDownloading: false,
      modalOpen: false,
      id: null,
      vesselName: '',
      flfFcOptions: []
    }
  },
  watch: {
    cargoContaminations: {
      handler(val) {
        this.tableData = val || []
      }
    },
    filters: {
      deep: true,
      handler() {
        this.fetchCargoContaminations()
      }
    },
    fileExport: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(val,  `Contamination Report ${this.vesselName}.xlsx`)

          this.$store.dispatch('CargoContamination/resetFileExport');
          this.isDownloading = false
        }
      }
    },
    flfFcNominates: {
      handler(val) {
        if (val) {
          this.flfFcOptions = val
        }
      }
    },
    me: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.filters.flf_fc_nominate = [{ value: val.flfFcNominate.id, text: val.flfFcNominate.name }]
        }
      }
    }
  },
  mounted() {
    this.fetchFlfFcNominates()
  },
  methods: {
    async fetchFlfFcNominates() {
      await this.$store.dispatch('VesselLineUp/getFlfFcNominates')
    },
    async fetchCargoContaminations() {
      this.isBusy = true
      try {
        const apiFilters = {
          sort_dir: this.filters?.sort_dir.toUpperCase(),
          sort_by: this.filters?.sort_by,
          page: this.currentPage || 1,
          limit: this.pageSize || 10,
          flf_fc_nominate: this.filters.flf_fc_nominate.map(item => item.value) || [],
          month_year: this.filters.month_year ? this.moment(this.filters.month_year).format('MM-YYYY') : null
        };

        await this.$store.dispatch('CargoContamination/fetchCargoContamination', apiFilters)
        this.isBusy = false
      } catch (err) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch cargo contamination list, please try again')
      }
    },
    async downloadReport(row) {
      if (this.isDownloading) return
      this.isDownloading = true
      this.isBusy = true
      this.vesselName = row.vessel_name
      try {
        await this.$store.dispatch('CargoContamination/exportCargoContamination', {
          vessel_line_up_id: row.vessel_line_up_id
        })
      } catch (err) {
        this.isDownloading = false
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to export file, please try again')
      }
    },
    sort(sortBy, sortDir) {
      this.filter.sort_by = sortBy
      this.filter.sort_dir = sortDir

      this.fetchCargoContaminations()
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  @apply w-full p-5 mt-5 flex flex-row items-center bg-white rounded-lg;
}

.icon-transparent-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  @apply bg-primary;
  border-radius: 0.5rem;

  &.disable {
    @apply cursor-default;
    background-color: #ECEBED;

    &.edit, img {
      filter: grayscale(100%);
    }
  }
}
</style>